import React from 'react';

const CookieModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-auto my-8 sm:my-16">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Zásady používání cookies</h2>
          <div className="flex items-center gap-2">
            <a
              href="/Zasady-cookies.txt"
              download="Zasady-cookies-Vyjednáme.txt"
              className="text-blue-600 hover:text-blue-700 text-sm font-medium px-3 py-1 rounded border border-blue-200 hover:border-blue-300 transition-colors"
              title="Stáhnout dokument"
            >
              📄 Stáhnout
            </a>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-xl font-bold"
            >
              ×
            </button>
          </div>
        </div>
        
        <div className="prose max-w-none text-gray-900">
          <h3 className="text-lg font-semibold mb-3 text-gray-900">Zásady používání cookies na webu Vyjednáme</h3>
          <p className="mb-4 text-gray-800"><strong>Verze: 1.0, účinná od 11. srpna 2025</strong></p>
          
          <p className="mb-4 text-gray-800">
            Tyto Zásady používání cookies (dále jen „Zásady") vysvětlují, jak společnost Vyjednáme, s.r.o., IČO 21377596, se sídlem Příčná 1892/4, Nové Město (Praha 1), 110 00 Praha (dále jen „společnost" nebo „my"), používá cookies a podobné technologie na našich webových stránkách <strong>www.vyjedname.cz</strong> (dále jen „web").
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">1. Co jsou cookies?</h4>
          <p className="mb-4 text-gray-800">
            Cookies jsou malé textové soubory, které se ukládají do vašeho zařízení (počítač, tablet, smartphone) při návštěvě webových stránek. Umožňují webové stránce zapamatovat si vaše aktivity a preference po určitou dobu, takže je nemusíte zadávat znovu při každé návštěvě stránky nebo při procházení mezi jednotlivými stránkami.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">2. Jaké cookies používáme a k čemu?</h4>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">2.1 Nezbytné cookies</h5>
          <p className="mb-2 text-gray-800">Tyto cookies jsou nezbytné pro správné fungování našeho webu a nelze je vypnout:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Souhlas s cookies:</strong> Ukládá informaci o vašem souhlasu s používáním cookies</li>
            <li><strong>Bezpečnostní cookies:</strong> Zajišťují bezpečnost a ochranu před útoky</li>
            <li><strong>Technické cookies:</strong> Umožňují základní funkčnost webu (navigace, přístup k chráněným sekcím)</li>
          </ul>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">2.2 Funkční cookies</h5>
          <p className="mb-2 text-gray-800">Tyto cookies zlepšují funkčnost webu a uživatelský zážitek:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Jazykové preference:</strong> Zapamatují si váš preferovaný jazyk</li>
            <li><strong>Nastavení webu:</strong> Ukládají vaše preference ohledně vzhledu a chování webu</li>
            <li><strong>Formuláře:</strong> Uchovávají data ve formulářích, abyste je nemuseli vyplňovat znovu</li>
          </ul>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">2.3 Analytické cookies</h5>
          <p className="mb-2 text-gray-800">Pomáhají nám pochopit, jak návštěvníci používají náš web:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Google Analytics:</strong> Shromažďuje anonymní statistiky o návštěvnosti</li>
            <li><strong>Sledování výkonu:</strong> Měří rychlost načítání stránek a technické problémy</li>
            <li><strong>Analýza chování:</strong> Pomáhá zlepšovat obsah a struktur webu</li>
          </ul>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">2.4 Marketingové cookies</h5>
          <p className="mb-2 text-gray-800">Používají se pro cílenou reklamu a marketing:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Reklamní sítě:</strong> Zobrazují relevantní reklamy na základě vašich zájmů</li>
            <li><strong>Retargeting:</strong> Umožňují zobrazovat naše reklamy na jiných webech</li>
            <li><strong>Sociální média:</strong> Integrují funkce sociálních sítí (Facebook, LinkedIn)</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">3. Doba uchování cookies</h4>
          <p className="mb-4 text-gray-800">Cookies rozdělujeme podle doby uchování:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Relační cookies:</strong> Automaticky se mažou po ukončení prohlížeče</li>
            <li><strong>Trvalé cookies:</strong> Zůstávají uložené po stanovenou dobu (obvykle 1-24 měsíců)</li>
            <li><strong>Analytické cookies:</strong> Uchovávány až 2 roky pro dlouhodobé analýzy</li>
            <li><strong>Marketingové cookies:</strong> Obvykle 30-90 dní pro reklamní účely</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">4. Vaše volby a práva</h4>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">4.1 Souhlas a jeho odvolání</h5>
          <p className="mb-4 text-gray-800">
            Svůj souhlas s používáním cookies můžete kdykoli odvolat změnou nastavení v prohlížeči nebo kontaktováním naší podpory. Upozorňujeme, že odmítnutí některých cookies může ovlivnit funkčnost webu.
          </p>
          
          <h5 className="font-medium mt-4 mb-2 text-gray-900">4.2 Nastavení v prohlížeči</h5>
          <p className="mb-2 text-gray-800">Cookies můžete spravovat v nastavení svého prohlížeče:</p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Chrome:</strong> Nastavení → Pokročilé → Soukromí a zabezpečení → Cookies</li>
            <li><strong>Firefox:</strong> Možnosti → Soukromí a zabezpečení → Cookies a data stránek</li>
            <li><strong>Safari:</strong> Předvolby → Soukromí → Cookies a data webů</li>
            <li><strong>Edge:</strong> Nastavení → Cookies a oprávnění webu</li>
          </ul>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">5. Cookies třetích stran</h4>
          <p className="mb-4 text-gray-800">
            Na našem webu mohou být používány cookies od třetích stran pro následující služby:
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li><strong>Google Analytics:</strong> Pro analýzu návštěvnosti (Google LLC)</li>
            <li><strong>Google Fonts:</strong> Pro načítání písem (Google LLC)</li>
            <li><strong>Cloudflare:</strong> Pro CDN a bezpečnost (Cloudflare Inc.)</li>
            <li><strong>Netlify/Vercel:</strong> Pro hosting a výkon webu</li>
          </ul>
          
          <p className="mb-4 text-gray-800">
            Tyto služby mají vlastní zásady cookies, se kterými se můžete seznámit na jejich webových stránkách.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">6. Zabezpečení</h4>
          <p className="mb-4 text-gray-800">
            Dbáme na to, aby cookies byly používány bezpečným způsobem. Používáme moderní šifrovací technologie a pravidelně aktualizujeme naše bezpečnostní opatření. Osobní údaje získané prostřednictvím cookies jsou chráněny v souladu s našimi zásadami ochrany osobních údajů (GDPR).
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">7. Změny těchto zásad</h4>
          <p className="mb-4 text-gray-800">
            Tyto zásady můžeme čas od času aktualizovat. O významných změnách vás budeme informovat na našem webu nebo e-mailem. Doporučujeme pravidelně kontrolovat tyto zásady pro nejnovější informace.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">8. Kontakt</h4>
          <p className="mb-4 text-gray-800">
            Pokud máte jakékoli otázky ohledně používání cookies na našem webu, kontaktujte nás:
          </p>
          <ul className="list-none mb-4 text-gray-800">
            <li><strong>E-mail:</strong> info@vyjedname.cz</li>
            <li><strong>Telefon:</strong> <a href="tel:+420606111895" className="text-blue-600 hover:text-blue-800 underline decoration-dotted">+420 606 111 895</a></li>
            <li><strong>Adresa:</strong> Příčná 1892/4, Nové Město (Praha 1), 110 00 Praha</li>
            <li><strong>Web:</strong> www.vyjedname.cz</li>
          </ul>
          
          <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <h5 className="font-medium mb-2 text-blue-900">Důležité upozornění</h5>
            <p className="text-sm text-blue-800">
              Používáním našeho webu souhlasíte s používáním cookies v souladu s těmito zásadami. 
              Pokud s používáním cookies nesouhlasíte, můžete je vypnout v nastavení svého prohlížeče, 
              ale upozorňujeme, že to může ovlivnit funkčnost některých částí webu.
            </p>
          </div>
          
          <div className="mt-4 text-sm text-gray-600">
            <p><strong>Dokument vytvořen:</strong> 11. srpna 2025</p>
            <p><strong>Poslední aktualizace:</strong> 11. srpna 2025</p>
            <p><strong>Verze:</strong> 1.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieModal;
